// src/modules/app-views/leads/pages/Init/components/tableColumns/assignmentColumn.js
import { UserOutlined, AppstoreOutlined, TagOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// Displays CRM assignment details after a lead is distributed:
//   - Offer name (offerData.name)
//   - Board name (boardData.name from sysSubscriptions CRM params)
//   - User who received the lead (assignedUser.name)
//   - Current responsible consultant (consultantData.name)
//
// All data is populated by the backend postAggregate in leadsService.getPagination.
// Empty when status === 'queue' (not yet distributed).
function assignmentColumn(buildColumnProps, options = {}) {
  const {
    key = 'assignment',
    title = 'assignment',
    dataIndex = 'assigned',
    width = 160,
    columnProps = { sort: false },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const isDistributed = r?.assigned?.accountId || r?.consultantId;
      if (!isDistributed) return <span style={{ color: '#bbb' }}>—</span>;

      const offerName     = r?.offerData?.name || null;
      const boardName     = r?.boardData?.name || null;
      const assignedName  = r?.assignedUser?.name || null;
      const consultantName = r?.consultantData?.name || null;

      return (
        <div className="d-flex flex-column" style={{ gap: 2 }}>
          {offerName && (
            <span style={{ fontSize: 12 }}>
              <TagOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
              {offerName}
            </span>
          )}
          {boardName && (
            <span style={{ fontSize: 12 }}>
              <AppstoreOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
              {boardName}
            </span>
          )}
          {assignedName && (
            <span style={{ fontSize: 12 }}>
              <UserOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
              {assignedName}
            </span>
          )}
          {consultantName && consultantName !== assignedName && (
            <span style={{ fontSize: 12, color: '#595959' }}>
              <UserOutlined style={{ marginRight: 4, color: '#1890ff' }} />
              {consultantName}
            </span>
          )}
        </div>
      );
    },
  };
}

export default assignmentColumn;
